export default function VpnService() {
  return (
    <section id="vpn-service" className="py-36 bg-gradient-to-b from-purple-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <div className="mb-4">
            <span className="text-purple-600 text-sm font-semibold tracking-widest uppercase">
              VPN SERVICE
            </span>
          </div>
          
          <h2 className="text-6xl font-bold text-gray-900 mb-6">
            Military-Grade Protection
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience unrestricted internet access with complete anonymity
          </p>
        </div>

        <div className="mb-20">
          <div className="flex items-center justify-center gap-12 lg:gap-24">
            <div className="flex flex-col items-center">
              <div className="w-24 h-24 bg-white rounded-2xl shadow-lg flex items-center justify-center mb-4 border border-purple-100">
                <i className="ri-smartphone-line text-purple-600 text-4xl"></i>
              </div>
              <p className="text-gray-700 font-medium">Your Device</p>
            </div>

            <div className="flex-1 max-w-xs relative">
              <div className="h-1 bg-gradient-to-r from-purple-600 to-purple-400 rounded-full relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent animate-pulse"></div>
              </div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <i className="ri-lock-line text-purple-600 text-2xl bg-white px-2"></i>
              </div>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-24 h-24 bg-gradient-to-br from-purple-600 to-purple-700 rounded-2xl shadow-xl flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-white text-4xl"></i>
              </div>
              <p className="text-gray-700 font-medium">VPN Server</p>
            </div>

            <div className="flex-1 max-w-xs relative">
              <div className="h-1 bg-gradient-to-r from-purple-400 to-purple-200 rounded-full relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent animate-pulse"></div>
              </div>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-24 h-24 bg-white rounded-2xl shadow-lg flex items-center justify-center mb-4 border border-purple-100">
                <i className="ri-global-line text-purple-600 text-4xl"></i>
              </div>
              <p className="text-gray-700 font-medium">Internet</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 border border-purple-100 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
            <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-shield-keyhole-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              AES-256 Encryption
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Bank-level encryption that keeps your data secure from hackers, ISPs, and government surveillance.
            </p>
          </div>

          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 border border-purple-100 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
            <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-eye-off-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Complete Anonymity
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Hide your IP address and browse the web without leaving any digital footprints behind.
            </p>
          </div>

          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 border border-purple-100 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
            <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-speed-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Lightning Fast
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Optimized servers worldwide ensure you get the fastest connection speeds without compromises.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
